module.exports = __webpack_public_path__ + "public/img/Menghitung Gaji Bersih Di Excel Untuk HR.a793cccf.png";